module.exports = __webpack_public_path__ + "919d834978d221d39c9044b55bb71a41.svg";